document.addEventListener('DOMContentLoaded', function () {
  const page = document.querySelector('[data-venture-compare-page]');

  if (!page) {
    return;
  }

  function triggerMainSlider(direction) {
    const selector =
      direction === 'left'
        ? '[data-venture-slider-left]'
        : '[data-venture-slider-right]';

    const button = page.querySelector(selector);

    if (button && !button.disabled) {
      button.click();
    }
  }

  function enhanceStickyHeader() {
    const sticky = page.querySelector(
      '[data-venture-sticky-compare]'
    );

    if (!sticky) {
      return;
    }

    if (sticky.dataset.ventureControlsReady === 'true') {
      return;
    }

    const inner = sticky.querySelector(
      '.venture-sticky-compare__inner'
    );

    const movables = sticky.querySelector(
      '.venture-sticky-compare__movables'
    );

    if (!inner || !movables) {
      return;
    }

    sticky.dataset.ventureControlsReady = 'true';

    /* -----------------------------------------------
       Sticky left arrow
       ----------------------------------------------- */

    const leftArrow = document.createElement('button');

    leftArrow.type = 'button';
    leftArrow.className =
      'venture-sticky-compare__arrow venture-sticky-compare__arrow--left';

    leftArrow.setAttribute(
      'aria-label',
      'Previous comparison bike'
    );

    leftArrow.innerHTML = '‹';

    leftArrow.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      triggerMainSlider('left');
    });

    /* -----------------------------------------------
       Sticky right arrow
       ----------------------------------------------- */

    const rightArrow = document.createElement('button');

    rightArrow.type = 'button';
    rightArrow.className =
      'venture-sticky-compare__arrow venture-sticky-compare__arrow--right';

    rightArrow.setAttribute(
      'aria-label',
      'Next comparison bike'
    );

    rightArrow.innerHTML = '›';

    rightArrow.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      triggerMainSlider('right');
    });

    inner.appendChild(leftArrow);
    inner.appendChild(rightArrow);

    /* -----------------------------------------------
       Drag / swipe behavior
       ----------------------------------------------- */

    let dragging = false;
    let moved = false;

    let startX = 0;
    let currentX = 0;
    let pointerId = null;

    function pointerDown(event) {
      if (
        event.pointerType === 'mouse' &&
        event.button !== 0
      ) {
        return;
      }

      dragging = true;
      moved = false;

      pointerId = event.pointerId;
      startX = event.clientX;
      currentX = startX;

      movables.classList.add('is-dragging');

      movables.setPointerCapture(pointerId);

      movables.style.transition = 'none';

      event.preventDefault();
    }

    function pointerMove(event) {
      if (!dragging) {
        return;
      }

      currentX = event.clientX;

      let delta = currentX - startX;

      if (Math.abs(delta) > 5) {
        moved = true;
      }

      /*
       * Limit the visual drag so the sticky row
       * doesn't expose a large empty area.
       */
      delta = Math.max(-85, Math.min(85, delta));

      movables.style.transform =
        'translate3d(' + delta + 'px, 0, 0)';

      event.preventDefault();
    }

    function finishDrag() {
      if (!dragging) {
        return;
      }

      dragging = false;

      movables.classList.remove('is-dragging');

      if (
        pointerId !== null &&
        movables.hasPointerCapture(pointerId)
      ) {
        movables.releasePointerCapture(pointerId);
      }

      const delta = currentX - startX;

      /*
       * Always snap the sticky strip back into
       * perfect alignment first.
       */
      movables.style.transition =
        'transform 140ms ease';

      movables.style.transform =
        'translate3d(0, 0, 0)';

      if (!moved) {
        return;
      }

      /*
       * Drag about 40px before changing bikes.
       *
       * Drag left  = next bike.
       * Drag right = previous bike.
       */
      if (delta <= -40) {
        window.setTimeout(function () {
          triggerMainSlider('right');
        }, 80);

        return;
      }

      if (delta >= 40) {
        window.setTimeout(function () {
          triggerMainSlider('left');
        }, 80);
      }
    }

    movables.addEventListener(
      'pointerdown',
      pointerDown
    );

    movables.addEventListener(
      'pointermove',
      pointerMove
    );

    movables.addEventListener(
      'pointerup',
      finishDrag
    );

    movables.addEventListener(
      'pointercancel',
      finishDrag
    );

    movables.addEventListener(
      'dragstart',
      function (event) {
        event.preventDefault();
      }
    );
  }

  /*
   * The main comparison script rebuilds the sticky header
   * after each slide, so watch for the new header and
   * automatically reconnect these controls.
   */
  const observer = new MutationObserver(function () {
    window.requestAnimationFrame(
      enhanceStickyHeader
    );
  });

  observer.observe(page, {
    childList: true,
    subtree: true
  });

  enhanceStickyHeader();
});